
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("\n")
    ;  for (var i = 0, iLen = list.length; i < iLen; i++) { 
    ; __append("\n\n\n")
    ;  if (type == 'danma') {
    ; __append("\n    <div class=\"c-chart__item clearfix\" data-offset=\"")
    ; __append(escape(list[i].offset))
    ; __append("\">\n        <img class=\"ifeng-logo\" src=\"")
    ; __append(escape(list[i].avatar))
    ; __append("\" alt=\"用户头像\"/>\n        <div class=\"saying\"><em class=\"c-chart__author\">")
    ; __append(escape(list[i].nickname))
    ; __append("</em>")
    ; __append(escape(list[i].content))
    ; __append("</div>\n    </div>\n")
    ; } else if(type == 'praise'){
    ; __append("\n    <div class=\"c-chart__item clearfix\" data-offset=\"")
    ; __append(escape(list[i].offset))
    ; __append("\">\n        <img class=\"ifeng-logo\" src=\"")
    ; __append(escape(list[i].avatar))
    ; __append("\" alt=\"用户头像\"/>\n        <div class=\"saying\"><em class=\"c-chart__author\">")
    ; __append(escape(list[i].nickname))
    ; __append("</em>\n            ")
    ;  if (list[i].praise_type == '2') {
    ; __append("\n                给主播点了赞\n            ")
    ;  } 
    ; __append("\n            ")
    ;  if (list[i].praise_type == '3') {
    ; __append("\n                点燃一根蜡烛\n            ")
    ;  } 
    ; __append("\n        </div>\n    </div>\n")
    ; } else if(type == 'gift'){
    ; __append("\n    <div class=\"c-chart__item c-chart-gift clearfix\" data-offset=\"0\">\n        <img class=\"abstract\" src=\"")
    ; __append(escape(list[i].avatar))
    ; __append("\" alt=\"用户头像\"/>\n        <div class=\"saying\">\n            <em class=\"c-chart__author\">")
    ; __append(escape(list[i].nickname))
    ; __append("</em>赠送<em class=\"gift-name\">")
    ; __append(escape(list[i].comboname))
    ; __append("</em>\n            <img class=\"gift-img\" src=\"")
    ; __append(escape(list[i].giftImg))
    ; __append("\" alt=\"")
    ; __append(escape(list[i].comboname))
    ; __append("\"/>\n        </div>\n    </div>\n")
    ; } else if(type == 'login'){
    ; __append("\n    <div class=\"c-chart__item c-chart-login clearfix\" data-offset=\"")
    ; __append(escape(list[i].offset))
    ; __append("\">\n        <img class=\"ifeng-logo\" src=\"")
    ;  __append(require("./ifeng-logo.png")) 
    ; __append("\" alt=\"用户头像\"/>\n        <div class=\"saying\">欢迎<em>")
    ; __append(escape(list[i].nickname))
    ; __append("</em>进入房间</div>\n    </div>\n")
    ; } else if(type == 'host'){
    ; __append(" \n    <div class=\"c-chart__item c-chart-host clearfix\" data-offset=\"")
    ; __append(escape(list[i].offset))
    ; __append("\">\n        <img class=\"ifeng-logo\" src=\"")
    ; __append(escape(list[i].avatar))
    ; __append("\" alt=\"用户头像\"/>\n        <div class=\"saying\"><em class=\"c-chart__author\">主持人")
    ; __append(escape(list[i].nickname))
    ; __append("</em>")
    ; __append(escape(list[i].content))
    ; __append("</div>\n    </div>\n")
    ; }
    ; __append("\n")
    ; }
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/zhujian/Desktop/code/live_system/live/modules/f.compenont.barrage.pc/app/modules/chartList/chatItem.ejs
// module id = 399
// module chunks = 0